export * from "-!../../node_modules/babel-loader/lib/index.js!../../node_modules/vue-loader/lib/loaders/templateLoader.js??ref--2!../../node_modules/vue-loader/lib/index.js??vue-loader-options!./Pagination.vue?vue&type=template&id=17c92100"


//////////////////
// WEBPACK FOOTER
// ./src/components/Pagination.vue?vue&type=template&id=17c92100
// module id = 1452
// module chunks = 31